import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCdyhJaEHmcWtjRW2MEmh3u0Q_Mdi2GV1E",
  authDomain: "classroom-c0e76.firebaseapp.com",
  databaseURL:
    "https://classroom-c0e76-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "classroom-c0e76",
  storageBucket: "classroom-c0e76.firebasestorage.app",
  messagingSenderId: "719175117153",
  appId: "1:719175117153:web:ba79aac2f749b29607bd20",
  measurementId: "G-G1ZYL86SQ9",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export default app;